"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVITATIONS_SERVICE_ENDPOINT = void 0;

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */
var INVITATIONS_SERVICE_ENDPOINT = 'https://invitations.adobe.io/api/v2';
exports.INVITATIONS_SERVICE_ENDPOINT = INVITATIONS_SERVICE_ENDPOINT;